export var AddonRowDataHooks = {
    THUMBNAIL: 'addon-row-thumbnail',
    NAME: 'addon-row-name',
    DURATION: 'addon-row-duration',
    PRICE: 'addon-row-price',
    ADD_BUTTON: 'addon-row-add-button',
    ADDED_BUTTON: 'addon-row-added-button',
    COUNTER: 'addon-row-counter',
    DISABLED_REASON: 'addon-row-disabled-reason',
};
//# sourceMappingURL=AddonRowDataHooks.js.map